import { dataKeyShift } from 'dls-icons-data'
import { createIcon } from '../common'

const IconKeyShift = /*#__PURE__*/createIcon(dataKeyShift)
export default IconKeyShift
